import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { GoToMembershipSettingsCTA } from "./ctas";

export const PauseMembershipIA: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => {
    return getAnswer(context, strictLocalize).getTitle();
  },

  descriptionBuilder: (context) => {
    return getAnswer(context, strictLocalize).getDescription();
  },

  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    linkBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.getLink?.();
    },
  },
});

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => PAUSE_YOUR_INSIDER_MEMBERSHIP(strictLocalize),
    getDescription: () => [
      IF_YOU_WOULD_LIKE_TO_PAUSE_YOUR_MEMBERSHIP(strictLocalize),
    ],
  };
};

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) => {
  return GoToMembershipSettingsCTA(strictLocalize);
};

const PAUSE_YOUR_INSIDER_MEMBERSHIP = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Pause your Insider membership",
    description: {
      text: "Title for the answer of Pause membership issue",
    },
  });

const IF_YOU_WOULD_LIKE_TO_PAUSE_YOUR_MEMBERSHIP = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "If you wish to pause your Insider membership, simply click on “Cancel Membership” within the “Insider Membership” tab of your Account settings. From there, you will have the option to pause your membership instead.",
  });
